import React from "react";
import { Factory } from "lucide-react";

const highlights = [
  { value: "Hasta 1.100.000", unit: "kg/mes", label: "Capacidad instalada total, todas las líneas" },
  { value: "Hasta 340.000", unit: "kg/mes", label: "Gainers · línea de mayor volumen" },
  { value: "Hasta 223.000", unit: "kg/mes", label: "WPC / WPI · proteína" },
  { value: "+13M", unit: "kg/año", label: "Capacidad instalada anual estimada, todas las líneas" },
];

export default function Capacity() {
  return (
    <section id="capacidad" className="relative py-10 md:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-10 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 05 · Capacidad productiva</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
            Producción a <span className="text-[#0A84E2]">escala real.</span>
          </h2>
          <p className="mt-6 text-slate-600 text-lg">Capacidad mensual estimada por familia de producto, a máximo rendimiento. Destacan los gainers y la proteína WPC / WPI como líneas de mayor volumen.</p>
        </div>

        {/* Highlights */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {highlights.map((h, i) => (
            <div key={i} data-testid={`capacity-highlight-${i}`} className="corp-card rounded-sm p-7 bg-gradient-to-br from-[#EFF6FF] to-white">
              <div className="flex items-center gap-2 text-[#0A84E2] mb-3">
                <Factory className="w-5 h-5" />
              </div>
              <div className="font-display text-3xl font-extrabold text-[#0A1628] leading-none">
                {h.value} <span className="text-base text-[#0A84E2]">{h.unit}</span>
              </div>
              <div className="mt-2 text-sm text-slate-600 font-medium">{h.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
